import { generateNumber } from './generateNumber.js';

export function populateNumbers(data, key = 'default') {
  if (!generateNumber.randomNumbers) generateNumber.randomNumbers = {};
  if (!generateNumber.randomNumbers[key]) generateNumber.randomNumbers[key] = [];
  if (Array.isArray(data)) {
    generateNumber.randomNumbers[key] = generateNumber.randomNumbers[key].concat(data);
  } else if (typeof data === 'number') {
    generateNumber.randomNumbers[key].push(data);
  }
  generateNumber.randomNumbers[key] = [...new Set(generateNumber.randomNumbers[key].sort())];
};